
// Sans-serif font options
const SANS_SERIF_FONTS = [
  { value: "roboto", label: "Roboto", className: "font-['Roboto']" },
  { value: "oswald", label: "Oswald", className: "font-['Oswald']" },
  { value: "playfair", label: "Playfair Display", className: "font-['Playfair Display']" },
];

// Handwritten/Script font options
const HANDWRITTEN_FONTS = [
  { value: "dancing-script", label: "Dancing Script", className: "font-['Dancing Script']" },
  { value: "pacifico", label: "Pacifico", className: "font-['Pacifico']" },
  { value: "permanent-marker", label: "Permanent Marker", className: "font-['Permanent Marker']" },
  { value: "satisfy", label: "Satisfy", className: "font-['Satisfy']" },
  { value: "caveat", label: "Caveat", className: "font-['Caveat']" },
];

export const LOGO_FONTS = [
  { label: "Sans Serif", fonts: SANS_SERIF_FONTS },
  { label: "Handwritten", fonts: HANDWRITTEN_FONTS }
].flatMap(category => category.fonts);

export const FONT_SIZES = [
  { value: "text-xxs", label: "XX Small" },
  { value: "text-xs", label: "X Small" },
  { value: "text-lg", label: "Small" },
  { value: "text-xl", label: "Medium" },
  { value: "text-2xl", label: "Large" },
  { value: "text-3xl", label: "Extra Large" },
];

export const FONT_WEIGHTS = [
  { value: "font-normal", label: "Regular" },
  { value: "font-medium", label: "Medium" },
  { value: "font-semibold", label: "Semi Bold" },
  { value: "font-bold", label: "Bold" },
];
